import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  return Yup.object({
    productCode: Yup.string().max(30, 'Maximum 30 characters'),
    prodShortName: Yup.string().max(100, 'Maximum 100 characters'),
    productCategoryCode: Yup.string().max(30, 'Maximum 30 characters')
  })
}

export default makeValidationSchema
